import React from 'react';
import { useTranslation } from 'react-i18next';
import { IDiscountType } from "../../../interfaces/IDiscounts";
import { useCurrencyState } from "../../../yoello-lib/modules/hooks/useCurrencyState";

export function DiscountTypeOnListItems({ type, key }: { type: IDiscountType, key: any }) {
  const currency = useCurrencyState();
  const {t} = useTranslation();
  return (
    <span key={key}>
      {type === IDiscountType.VALUE ? t(`currencies.${currency.iso_code}`) : `${t(`misc.Percentage`)} (%)`}
    </span>
  )
}
